import React from 'react';
import { useSearchParams } from 'react-router-dom';

import Header from 'components/shared/Header/Header';
import ToggleSwitch from 'components/shared/ToggleSwitch/ToggleSwitch';

import ReportListView from '../../components/ReportListView/ReportListView';
import { TABS } from '../../lib/constants';

const StandardReports = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const category = searchParams.get('category') || TABS[0].value;

  const handleClick = (item) => setSearchParams({ category: item.value });

  const activeItem = TABS.find((item) => category === item.link);

  return (
    <div className="flex flex-col bg-white">
      <Header title="Standard Reports" childrenClassName="!justify-start">
        <ToggleSwitch
          items={TABS}
          active={activeItem?.value}
          onClick={handleClick}
          horizontalScroll
        />
      </Header>

      <ReportListView />
    </div>
  );
};

export default StandardReports;
